module.exports = "pegasus_template/assets/image-3-basic.png";